const COLORS = { ok: "bg-emerald-500", warning: "bg-amber-500", over: "bg-red-500" };

// `spent` is committed + actual — everything the budget has used up.
export default function CostHealthBar({ spent, budgetTotal, health, testId }) {
  if (!budgetTotal) return null;
  const pct = Math.max(0, Math.min((Number(spent || 0) / budgetTotal) * 100, 100));
  return (
    <div className="w-full h-2 rounded-full bg-slate-100 overflow-hidden" data-testid={testId || "cost-health-bar"}>
      <div className={`h-full rounded-full ${COLORS[health] || "bg-slate-400"}`} style={{ width: `${pct}%` }} />
    </div>
  );
}
